export const presentationData = [
    {
        'id': 'Самарская область',
        'title': 'Самарская',
        'link': 'https://ksdm.geosamara.ru/samarskaya_obl'
    },
    {
        'id': 'Татарстан',
        'title': 'Татарстан',
        'link': 'https://ksdm.geosamara.ru/tatarstan'
    },
    {
        'id': 'Нижегородская область',
        'title': 'Нижегородская',
        'link': 'https://ksdm.geosamara.ru/nizhegorodskaya_obl'
    },
    {
        'id': 'Башкортостан',
        'title': 'Башкортостан',
        'link': 'https://ksdm.geosamara.ru/bashkortostan'
    },
    {
        'id': 'Пермский край',
        'title': 'Пермский',
        'link': 'https://ksdm.geosamara.ru/permskiy_kray'
    },
    {
        'id': 'Ульяновская область',
        'title': 'Ульяновская',
        'link': 'https://ksdm.geosamara.ru/ulyanovskaya_obl'
    },
    {
        'id': 'Оренбургская область',
        'title': 'Оренбургская',
        'link': 'https://ksdm.geosamara.ru/orenburgskaya_obl'
    },
    {
        'id': 'Пензенская область',
        'title': 'Пензенская',
        'link': 'https://ksdm.geosamara.ru/penzenskaya_obl'
    },
    {
        'id': 'Удмуртия',
        'title': 'Удмуртия',
        'link': 'https://ksdm.geosamara.ru/udmurtia'
    },
    {
        'id': 'Чувашия',
        'title': 'Чувашия',
        'link': 'https://ksdm.geosamara.ru/udmurtia'
    },
    {
        'id': 'Мордовия',
        'title': 'Мордовия',
        'link': 'https://ksdm.geosamara.ru/mordovia'
    },
    {
        'id': 'Кировская область',
        'title': 'Кировская',
        'link': 'https://ksdm.geosamara.ru/kirovskaya_obl'
    },
    {
        'id': 'Марий Эл',
        'title': 'Марий Эл',
        'link': 'https://ksdm.geosamara.ru/mari_el'
    },
    {
        'id': 'Саратовская область',
        'title': 'Саратовская',
        'link': 'https://ksdm.geosamara.ru/saratovskaya_obl'
    }
]

